import { render, staticRenderFns } from "./PostSmallBlockHorizontal.vue?vue&type=template&id=20817c1c&v-slot=color&"
import script from "./PostSmallBlockHorizontal.vue?vue&type=script&lang=js&"
export * from "./PostSmallBlockHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./PostSmallBlockHorizontal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports